export const VERSION = '2.35.2';
